'use strict';

var novicell = novicell || {};

novicell.oTrainingList = novicell.oTrainingList || function () {
    function init(){
        setTextHeight();
    }
    function setTextHeight(element) {
        
        var oTrainingLists = document.querySelectorAll('.o-training');
        for(var i = 0 ; i < oTrainingLists.length ; i++){
            var texts = oTrainingLists[i].querySelectorAll('.o-listTraining__text');
            var maxHeight = 0;
            for(var k = 0 ; k < texts.length ; k++){
                texts[k].style.height='';
            }
            if (window.innerWidth >= 768) {
                for(var j = 0 ; j < texts.length ; j++){
                    var currentTextHeight = texts[j].offsetHeight;
                    maxHeight = currentTextHeight>maxHeight?currentTextHeight:maxHeight;
                }
            }else{
                maxHeight='';
            }
            maxHeight=maxHeight!=''?maxHeight+'px':maxHeight;
            for(var l = 0 ; l < texts.length ; l++){
                texts[l].style.height=maxHeight;
            }
        }
    }

    return {
        init: init,
        setTextHeight:setTextHeight
    };

}();
